module.exports = __webpack_public_path__ + "static/element-c49b0227730d22bb89354609e4008397.png";